import { useMemo } from "react";
import { getContainerEffectProps } from "../utils/containerEffectUtils";

/**
 * Hook that computes overlay props for a container effect.
 *
 * @param {Object} data - Element data containing a `container_effect` key.
 * @returns {{ effectClassName: string, effectStyle: Object, hasEffect: boolean }}
 */
export default function useContainerEffect(data) {
  const containerEffect = data?.container_effect;

  return useMemo(() => {
    const { className, style, active } = getContainerEffectProps(containerEffect);
    return { effectClassName: className, effectStyle: style, hasEffect: active };
  }, [
    containerEffect?.effect,
    containerEffect?.intensity,
    containerEffect?.color_tint,
    containerEffect?.blur_amount,
    containerEffect?.animated,
    containerEffect?.shadow_direction,
  ]);
}
